// removed by extract-text-webpack-plugin
module.exports = {"DeviceConfigContainer":"jiH4xGNLqKEpfvO3zew6W","paginContainer":"snNZC2fOnzrPbivMzfNh-","nullContainer":"G3qCdNLTjndyitK0_viOX"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/DeviceConfig/DeviceConfig.less
// module id = 1609
// module chunks = 0